export const environment = {
	production: true,
	pictureBaseUrl: 'https://files.thegoodcar.fr',
};
